/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Reasoning_Present_4Inputs */



/**
* | output |
* | --- |
* | "piecing it together" |
*
* @param {Chat_Summary_Reasoning_Present_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_reasoning_present_4 = /** @type {((inputs?: Chat_Summary_Reasoning_Present_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Reasoning_Present_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("füge es zusammen")
	return /** @type {LocalizedString} */ ("piecing it together")
});